import { render } from "./MenuRoot.vue?vue&type=template&id=4360972b&ts=true"
import script from "./MenuRoot.vue?vue&type=script&setup=true&lang=ts"
export * from "./MenuRoot.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/primitives/menu/MenuRoot.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4360972b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4360972b', __exports__)) {
    api.reload('4360972b', __exports__)
  }
  
  module.hot.accept("./MenuRoot.vue?vue&type=template&id=4360972b&ts=true", () => {
    api.rerender('4360972b', render)
  })

}


export default __exports__